import React from 'react'
import { Box, Typography } from '@material-ui/core'
import clsx from 'clsx'
import {
  Edit as EditIcon,
  Inbox as InboxIcon,
  Star as StarIcon,
  Clock as ClockIcon,
  Send as SendIcon,
  FileText as DraftIcon,
  ChevronDown as ChevronDownIcon,
} from 'react-feather'

import useStyles from './styles'

const INBOX_ITEMS = [
  { icon: InboxIcon, label: 'Caixa de entrada', count: 3, active: true },
  { icon: StarIcon, label: 'Favoritos' },
  { icon: ClockIcon, label: 'Adiados' },
  { icon: SendIcon, label: 'Enviados' },
  { icon: DraftIcon, label: 'Rascunhos', count: 1 },
  { icon: ChevronDownIcon, label: 'Mais' },
]

const EmailSidebar = () => {
  const classes = useStyles()

  return (
    <Box className={classes.sidebar}>
      <Box className={classes.sidebarCompose}>
        <EditIcon size={18} />
        <Typography className={classes.sidebarComposeText}>Escrever</Typography>
      </Box>

      <Box className={classes.sidebarNav}>
        {INBOX_ITEMS.map(({ icon: Icon, label, count, active }) => (
          <Box
            key={label}
            className={clsx(classes.sidebarItem, {
              [classes.sidebarItemActive]: active,
            })}
          >
            <Icon size={16} className={classes.sidebarItemIcon} />
            <Typography className={classes.sidebarItemLabel}>
              {label}
            </Typography>
            {count !== undefined && (
              <Typography className={classes.sidebarItemCount}>
                {count}
              </Typography>
            )}
          </Box>
        ))}
      </Box>

      <Box className={classes.sidebarSection}>
        <Typography className={classes.sidebarSectionTitle}>Meet</Typography>
        <Typography className={classes.sidebarSectionItem}>
          Nova reunião
        </Typography>
        <Typography className={classes.sidebarSectionItem}>
          Entrar em uma reunião
        </Typography>
      </Box>

      <Box className={classes.sidebarSection}>
        <Typography className={classes.sidebarSectionTitle}>
          Hangouts
        </Typography>
        <Box className={classes.sidebarHangoutsBtn}>
          <Typography className={classes.sidebarHangoutsBtnText}>
            Sign in
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default EmailSidebar
